export default __webpack_public_path__ + "static/media/uesc.53287a93.png";